import { useI18n } from '@i18n/useI18n';
import React, { memo, useEffect, useState } from 'react';
import db from '@utils/db';
import { useStore } from '@store/appStore';
import { useWindowSize } from 'react-use';
import { breakpoints } from '@styles/tokens';
import DefaultTemplate from '@templates/DefaultTemplate';
import { Wrapper } from '../../GridCards/Common.styled';
import Teacher from '@components/Teacher';
import { useAuthentication } from '@providers/AuthProvider';
import Counselor from '@components/Counselor';

export const CounselorPage = () => {

  return (
    <DefaultTemplate>
        <Counselor />
    </DefaultTemplate>
  );
};

export default memo(CounselorPage);
